import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getValidToken } from "../../../utils/tokenManager";
import axios from "axios";
import Button from "../../common/Button";
import warning from "../../../assets/agent/warning.svg";
import success from "../../../assets/agent/success.svg";

function SendCommentModal({ open, onClose, dashboardData, comment }) {
  const modalRef = useRef(null);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [successModal, setSuccessModal] = useState(false);
  const agentId = sessionStorage.getItem("agentId");

  const handleBackdropClick = (e) => {
    if (modalRef.current && e.target === modalRef.current) {
      onClose();
    }
  };

  const onSendComment = async () => {
    try {
      const accessToken = await  getValidToken();
      const data = {
        AgentId: agentId,
        ClientID: dashboardData.client_id,
        Comments: comment || "",
        TotalCallsAnswered: dashboardData.total_calls_answered || 0,
        TotalCallsMade: dashboardData.total_calls_made || 0,
        TotalContactsRemaining: dashboardData.total_contacts_remaining || 0,
        TotalDiscarded: dashboardData.total_discarded || 0,
        TotalLeads: dashboardData.total_leads || 0,
        TotalMeetingsBooked: dashboardData.total_meetings_booked || 0,
        TotalMeetingsConfirmedAttended:
          dashboardData.total_meetings_confirmed_attended || 0,
      };

      await axios.post(
        `${process.env.REACT_APP_APIBASEURL}/api/users/agent-report`,
        data,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      setSuccessModal(true);
      setTimeout(() => {
        onClose();
        localStorage.removeItem("authToken");
        navigate("/");
      }, 2000);
    } catch (error) {
      console.error("Error sending report:", error);
    }
  };

  if (!open) return null;

  return (
    <>
      <div
        ref={modalRef}
        onClick={handleBackdropClick}
        className="fixed inset-0 z-50 flex items-center justify-center bg-[#000] bg-opacity-30 px-4"
      >
        <div className="bg-white rounded-2xl text-primary text-xl shadow-xl w-full max-w-[660px] p-7 relative flex flex-col items-center space-y-6">
          <img src={warning} alt="warning" className="w-[60px] h-[60px]" />
          <p className="mb-1 text-xl font-bold text-center">
            {t("agent.achieve.commentMod")}
          </p>
          <div className="relative flex items-center">
            <span className="absolute left-0 w-1 h-1 bg-[#0A1E4C] rounded-full -ml-1"></span>
            <hr className="flex-1 border-t-2 border-[#0A1E4C] w-[350px]" />
            <span className="absolute right-0 w-1 h-1 bg-[#0A1E4C] rounded-full -mr-1"></span>
          </div>
          <p className="my-4 text-xl w-[370px] text-center">
            {t("agent.achieve.commentModDesc")}?
          </p>

          <div className="flex gap-14 flex-wrap justify-center">
            <Button
              variant="secondary"
              className="w-full sm:w-48 px-4 py-2"
              onClick={onClose}
            >
              {t("agent.nextCall.keep")}
            </Button>
            <Button
              variant="primary"
              className="w-full sm:w-48 px-4 py-2"
              onClick={onSendComment}
            >
              {t("agent.noteInfo.yes")}, {t("continue")}
            </Button>
          </div>
        </div>
      </div>

      {successModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-[#000] bg-opacity-30 px-4">
          <div className="bg-white rounded-lg text-primary text-xl shadow-xl w-full max-w-[660px] p-6 relative flex flex-col items-center">
            <img
              src={success}
              alt="success"
              className="w-[60px] h-[60px] mb-4"
            />
            <p className="mb-4 text-xl font-bold">
              {t("agent.achieve.commentModsuccess.head")}
            </p>
          </div>
        </div>
      )}
    </>
  );
}

export default SendCommentModal;
